import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { MainLayoutComponent } from './shared/components/main-layout/main-layout/main-layout.component';
import { SearchComponent } from './search/search.component';
import { TermsOfConditionsComponent } from './terms-of-conditions/terms-of-conditions.component';
import { ContactComponent } from './contact/contact.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
// import { USER_ROUTES } from './user/user.routes';
// import { LISTING_ROUTES } from './listing/listing.routes';
// import { AUTH_ROUTES } from './auth/auth.routes';
import { EmailVerificationComponent } from './auth/email-verification/email-verification.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';

export const routes: Routes = [
  {
    // this route is not in the auth_routes because we don't want the main layout to be rendered!!
    path: 'auth/verify',
    component: EmailVerificationComponent,
  },
  {
    // this route is not in the auth_routes because we don't want the main layout to be rendered!!
    path: 'auth/reset-password/:token',
    component: ResetPasswordComponent,
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'auth',
        // children: AUTH_ROUTES,
        loadChildren: () =>
          import('../presentation/auth/auth.routes').then((m) => m.AUTH_ROUTES),
      },
      {
        path: 'listing',
        // children: LISTING_ROUTES,
        loadChildren: () =>
          import('../presentation/listing/listing.routes').then(
            (m) => m.LISTING_ROUTES
          ),
      },
      {
        path: 'user',
        // children: USER_ROUTES,
        loadChildren: () =>
          import('../presentation/user/user.routes').then((m) => m.USER_ROUTES),
      },
      {
        path: 'terms-and-conditions',
        component: TermsOfConditionsComponent,
      },
      {
        path: 'contact',
        component: ContactComponent,
      },
      {
        path: 'not-found',
        component: PageNotFoundComponent,
      },
      {
        path: 'search',
        component: SearchComponent,
      },
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: ':slug',
        component: HomeComponent,
      },

      //We add wild card if no route is found
      {
        path: '**',
        redirectTo: '/not-found',
      },
    ],
  },
];
